import React from "react";
import {
  Button,
  ButtonToolbar,
  Card,
  Form,
  FormControl,
  InputGroup,
} from "react-bootstrap";
import { useFormik } from "formik";
import { fetchTeams } from "../../_redux/teamsSlice";
import { useDispatch } from "react-redux";
import { injectIntl } from "react-intl";

interface TeamSearchProps {
  intl: any;
}

const TeamSearch: React.FC<TeamSearchProps> = ({ intl }: TeamSearchProps) => {
  const dispatch = useDispatch();

  const searchForm = useFormik({
    initialValues: { searchText: "" },
    onSubmit(values, { setFieldValue }) {
      if (!values.searchText) return;
      dispatch(fetchTeams({ searchText: values.searchText, pageNumber: 0 }));
      setFieldValue("searchText", "");
    },
  });

  return (
    <Card>
      <Card.Body>
        <Form onSubmit={searchForm.handleSubmit}>
          <Form.Group
            controlId="search-teams"
            className="mb-0 search-teams-form"
          >
            <div className="d-flex">
              <InputGroup className="mr-3" size="lg">
                <InputGroup.Prepend>
                  <InputGroup.Text
                    className="input-group-text pr-0 bg-transparent border-right-0"
                    defaultValue={searchForm.values.searchText}
                    onChange={searchForm.handleChange}
                  >
                    <i className="text-muted flaticon-search" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  onChange={searchForm.handleChange}
                  name={"searchText"}
                  placeholder={intl.formatMessage({
                    id: "TEAM.SEARCH.PLACE_HOLDER",
                  })}
                  className="border-left-0"
                />
              </InputGroup>
              <Button
                variant="primary"
                as="input"
                type="submit"
                value={intl.formatMessage({ id: "COMMON.SEARCH_BUTTON" })}
                className="w-100px"
              />
            </div>
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default injectIntl(TeamSearch);
